/** Marketing copy for landing pricing cards. Numeric quotas come from /api/public/plans. */

/** @param {any} plan */
export function includedTeamLabel(plan) {
  if (plan?.included_team_seats == null && (plan?.additional_seats == null || plan?.additional_seats_unlimited)) {
    return 'Unlimited team users';
  }
  const count = plan?.included_team_seats != null
    ? Number(plan.included_team_seats)
    : Number(plan?.additional_seats) + 1;
  return `${count} team users included`;
}

/** @param {any} plan */
export function extraSeatPriceLabel(plan) {
  const price = Number(plan?.extra_seat_price_usd);
  const shown = Number.isFinite(price) ? (price % 1 === 0 ? `$${price}` : `$${price.toFixed(2)}`) : '$2';
  return `Extra seat ${shown}/month`;
}
export const LITE_INCLUDED_MESSAGES = 550;
export const PLAN_LANDING_COPY = {
  lite: {
    tier: 'SOLO',
    blurb: 'For solo businesses with light daily message volume.',
    included: ['Instagram & Facebook messages', 'Saved Smart Answers', 'Owner account'],
    missing: 'No comments, WhatsApp or TikTok',
  },
  starter: {
    tier: 'SMALL BUSINESS',
    blurb: 'For small businesses adding comments and WhatsApp.',
    included: [
      'Instagram & Facebook messages + comments',
      'WhatsApp messages',
      'Saved Smart Answers',
    ],
    missing: 'TikTok not included',
  },
  growth: {
    tier: 'GROWING BUSINESS',
    blurb: 'For growing businesses active across every channel.',
    included: ['All channels included', 'Messages + comments', 'Saved Smart Answers'],
    missing: null,
    recommended: true,
  },
  pro: {
    tier: 'HIGH VOLUME',
    blurb: 'For busy teams handling high customer volume.',
    included: ['All channels included', 'Messages + comments', 'Saved Smart Answers'],
    missing: null,
  },
  max: {
    tier: 'MAXIMUM SCALE',
    blurb: 'For established businesses needing maximum AI capacity.',
    included: ['All channels included', 'Messages + comments', 'Saved Smart Answers'],
    missing: null,
  },
};
